var _PageLoader;
import { AuthCentralizedProvider } from '@crehana/auth';
import { PageLoader } from '@crehana/compass.ui/v2';
import { useUserPermissions } from "../hooks/use-user-permissions";
import { jsx as _jsx } from "react/jsx-runtime";
export var CentralizedUserSessionLayout = function CentralizedUserSessionLayout(_ref) {
  var children = _ref.children;
  var _useUserPermissions = useUserPermissions({}),
    me = _useUserPermissions.me,
    loading = _useUserPermissions.loading,
    slug = _useUserPermissions.slug;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (loading) return _PageLoader || (_PageLoader = /*#__PURE__*/_jsx(PageLoader, {}));
  if (!me || !me.organization || !me.organization.id || !slug) {
    console.error('Error: Malformed me object', me);
    return null;
  }
  return /*#__PURE__*/_jsx(AuthCentralizedProvider, {
    organizationSlug: slug,
    children: children
  });
};